<template>
  <div id="happilyVillageContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img class="icon-pages" src="../assets/images/navbar/ic_happily_village.webp" />
        <span class="page-title">{{ $t('page.happilyVillage') }}</span>
        <span class="page-des ml-16">{{ $t('page.happilyVillage_description') }}</span>
      </div>
      <el-tabs class="styleTab" v-model="activeName">
        <el-tab-pane name="overview" default>
          <span slot="label" class="title-bar">{{ $t('page.overview') }}</span>
          <overview @tabChanged="tabChange" v-if="activeName == 'overview'" />
        </el-tab-pane>
        <el-tab-pane name="university">
          <span slot="label" class="title-bar">{{ $t('page.university') }}</span>
          <university v-if="activeName == 'university'" />
        </el-tab-pane>
        <el-tab-pane name="townHall">
          <span slot="label" class="title-bar">{{ $t('page.townHall') }}</span>
          <town-hall v-if="activeName == 'townHall'" />
        </el-tab-pane>
        <el-tab-pane name="runningTrack">
          <span slot="label" class="title-bar">{{ $t('page.runningTrack') }}</span>
          <running-track v-if="activeName == 'runningTrack'" />
        </el-tab-pane>
        <el-tab-pane name="battleStadium">
          <span slot="label" class="title-bar">{{ $t('page.battleStadium') }}</span>
          <battle-stadium v-if="activeName == 'battleStadium'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "happily-village",
  components: {
    overview: require("./happily-village/overview").default,
    university: require("./happily-village/university").default,
    townHall: require("./happily-village/town-hall").default,
    runningTrack: require("./happily-village/running-track").default,
    battleStadium: require("./happily-village/battle-stadium").default
  },
  data() {
    return {
      activeName: "overview",
      anchor: {
        overview: "overview",
        university: "university",
        townHall: "townHall",
        runningTrack: "runningTrack",
        battleStadium: "battleStadium",
      }
    };
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "happily-village", params: { tab } });
        }
      }
    }
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else {
      this.$router.push({ name: 'happily-village', params: { tab: "overview" } })
    }
    this.$root.$on('changeTab', (item) => {
      if (item.path == "happily-village") {
        this.tabChange(item.tab);
      }
    });
  },
  methods: {
    tabChange(tab) {
      console.log('tabChange',tab)
      this.activeName = tab;
    }
  }
};
</script>

<style lang="scss" scoped>
.styleTab {
  margin-top: 32px;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
}
</style>
<style lang="scss">
#happilyVillageContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#happilyVillageContainer .el-tabs__item.is-active {
  color: #000000;
  font-weight: 700;
  font-size: 18px;
}
#happilyVillageContainer .el-tabs__header {
  margin: 0;
}
#happilyVillageContainer .el-input__inner {
  height: 46px;
}
#runningTrack .el-tabs__item.is-active,
#overview .el-tabs__item.is-active {
  color: #000;
  font-size: 15px;
}
#overview .el-tabs__item,
#runningTrack .el-tabs__item {
  font-size: 15px;
  height: 42px;
  line-height: 42px;
  width: 133px;
  text-align: left;
  transition: .3s;
  padding-left: 0;
  color: #000;
  &:hover {
    color: #000;
  }
}
#battle_stadium_tab .el-tabs__item.is-active {
  color: #000;
  font-size: 18px;
}
#battle_stadium_tab .el-tabs__item {
  font-size: 18px;
  height: 42px;
  line-height: 42px;
  width: 110px;
  text-align: left;
  transition: .3s;
  padding-left: 0;
  color: #000;
  &:hover {
    color: #000;
  }
}
</style>
